// Content data for ACDC-Formation x FormActionPro

export const heroContent = {
  badge: "IA Générative • Automatisation • Management • Digital & Web",
  title: "Transformez votre organisation. Accélérez votre performance. Libérez le potentiel de l'IA dans votre entreprise.",
  subtitle: "Libérez du temps, structurez vos processus avec toute la maîtrise nécessaire au développement de votre activité, grâce à des solutions concrètes en IA générative, automatisation et stratégie digitale adaptées à votre réalité métier.",
  cta1: "Faire le diagnostic gratuit",
  cta2: "Découvrir nos offres",
  badges: [
    { icon: "Shield", text: "Certifié Qualiopi" },
    { icon: "Users", text: "500+ entreprises formées" },
    { icon: "Clock", text: "ROI en 3 mois" },
  ],
};

export const painPoints = [
  {
    icon: "Clock",
    title: "Vous manquez de temps",
    description: "Les tâches administratives et répétitives vous empêchent de vous concentrer sur votre cœur de métier.",
  },
  {
    icon: "TrendingDown",
    title: "Vous perdez des clients",
    description: "Vos concurrents utilisent déjà l'IA et offrent des services plus rapides et personnalisés.",
  },
  {
    icon: "DollarSign",
    title: "Vos coûts explosent",
    description: "Les processus manuels coûtent cher en temps et en ressources humaines.",
  },
  {
    icon: "HelpCircle",
    title: "Vous ne savez pas par où commencer",
    description: "L'IA vous semble complexe, technique et inaccessible pour votre activité.",
  },
  {
    icon: "AlertTriangle",
    title: "Vous avez peur de vous tromper",
    description: "Investir dans la mauvaise solution ou former vos équipes sur des outils obsolètes.",
  },
  {
    icon: "UserX",
    title: "Vous êtes seul(e) face au changement",
    description: "Pas d'expert en interne pour vous guider dans cette transformation digitale.",
  },
];

export const services = [
  {
    icon: "GraduationCap",
    title: "Formations IA sur mesure",
    description: "Programmes adaptés à votre secteur et votre niveau. De la sensibilisation à l'expertise, nous formons vos équipes aux outils qui feront la différence.",
    features: ["ChatGPT & Copilot", "Automatisation no-code", "Prompting avancé", "IA dans votre métier"],
  },
  {
    icon: "Cog",
    title: "Audit & Conseil",
    description: "Analyse complète de vos processus pour identifier les opportunités d'automatisation et les gains de productivité immédiats.",
    features: ["Cartographie des tâches", "Étude de faisabilité", "Recommandations actionnables", "Plan de déploiement"],
  },
  {
    icon: "Rocket",
    title: "Accompagnement terrain",
    description: "Nous déployons avec vous les solutions et formons vos équipes jusqu'à l'autonomie complète. Support continu inclus.",
    features: ["Mise en place guidée", "Formation pratique", "Suivi personnalisé", "Support 6 mois"],
  },
];

export const methodology = [
  {
    step: 1,
    title: "Diagnostic",
    description: "Analyse de votre activité, identification des tâches automatisables et évaluation de votre maturité digitale.",
    duration: "1-2 jours",
  },
  {
    step: 2,
    title: "Stratégie",
    description: "Définition des priorités, sélection des outils adaptés et planification du déploiement.",
    duration: "2-3 jours",
  },
  {
    step: 3,
    title: "Formation",
    description: "Sessions pratiques sur les outils sélectionnés, cas d'usage concrets de votre métier.",
    duration: "2-5 jours",
  },
  {
    step: 4,
    title: "Déploiement",
    description: "Mise en place des automatisations, intégration dans vos processus existants.",
    duration: "1-2 semaines",
  },
  {
    step: 5,
    title: "Suivi",
    description: "Accompagnement continu, optimisation des workflows et formation complémentaire si nécessaire.",
    duration: "6 mois",
  },
];

export const useCases = [
  {
    id: "artisans",
    title: "Artisans & BTP",
    image: "https://static.prod-images.emergentagent.com/jobs/d9fe1d97-b0bb-45b5-8211-6a8ef2102d3f/images/f88425b85f4012818d6f93f628d8b0540637fe25975d6a653c66f55f5637732e.png",
    examples: [
      "Génération automatique de devis depuis photos du chantier",
      "Planification intelligente des interventions",
      "Relances clients automatisées",
      "Gestion des stocks prédictive",
    ],
    result: "Gain moyen de 8h/semaine sur l'administratif",
  },
  {
    id: "restaurateurs",
    title: "Restaurateurs & Hôteliers",
    image: "https://static.prod-images.emergentagent.com/jobs/d9fe1d97-b0bb-45b5-8211-6a8ef2102d3f/images/317770285671f5085f807dd6124e66cd4f140308c0b2be0f98f55a3927fdfbb9.png",
    examples: [
      "Menu du jour généré selon les stocks",
      "Mise à jour de votre site Web",
      "Prévision des réservations et staffing",
      "Création de contenus réseaux sociaux",
    ],
    result: "Augmentation de 25% des réservations en ligne",
  },
  {
    id: "services",
    title: "Entreprises de services",
    image: "https://static.prod-images.emergentagent.com/jobs/d9fe1d97-b0bb-45b5-8211-6a8ef2102d3f/images/717fa58e2589baeec600f4a7da3df65cec1e90fc06479e999ddc96963bb498de.png",
    examples: [
      "Rédaction automatique de comptes-rendus",
      "Qualification des leads entrants",
      "Propositions commerciales personnalisées",
      "Veille concurrentielle automatisée",
    ],
    result: "Productivité commerciale +40%",
  },
  {
    id: "liberal",
    title: "Professions libérales",
    image: "https://static.prod-images.emergentagent.com/jobs/d9fe1d97-b0bb-45b5-8211-6a8ef2102d3f/images/2e47bd75d0a93bb987877a387a14be0e6668db9822bc82716d18114711151922.png",
    examples: [
      "Synthèse automatique de documents",
      "Recherche documentaire intelligente",
      "Rédaction d'emails et courriers types",
      "Gestion agenda et rappels automatisés",
    ],
    result: "2h économisées par jour en moyenne",
  },
];

export const pricing = [
  {
    name: "Découverte",
    price: "Sur devis",
    period: "",
    description: "Idéal pour comprendre le potentiel de l'IA dans votre activité",
    features: [
      "Formation découverte (1 jour)",
      "Introduction ChatGPT & outils IA",
      "3 cas d'usage personnalisés",
      "Support email 1 mois",
      "Accès ressources en ligne",
    ],
    cta: "Choisir Découverte",
    featured: false,
  },
  {
    name: "Transformation",
    price: "Sur devis",
    period: "",
    description: "Pour passer à l'action et transformer vos processus",
    features: [
      "Audit complet (2 jours)",
      "Formation équipe (3 jours)",
      "5 automatisations déployées",
      "Support prioritaire 3 mois",
      "2 sessions de suivi",
      "Accès communauté privée",
    ],
    cta: "Choisir Transformation",
    featured: true,
  },
  {
    name: "Excellence",
    price: "Sur devis",
    period: "",
    description: "Accompagnement complet pour une transformation durable",
    features: [
      "Tout Transformation inclus",
      "Accompagnement 6 mois",
      "Automatisations illimitées",
      "Formation continue équipe",
      "Consultant dédié",
      "Reporting mensuel ROI",
    ],
    cta: "Demander un devis",
    featured: false,
  },
];

export const testimonials = [
  {
    name: "Marie",
    role: "Gérante",
    company: "Boulangerie artisanale",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    quote: "Grâce à la formation, j'ai automatisé mes commandes fournisseurs et ma comptabilité. Je gagne 6 heures par semaine !",
    rating: 5,
  },
  {
    name: "Jean-Pierre",
    role: "Architecte",
    company: "Cabinet d'architecture",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop",
    quote: "L'IA m'aide maintenant à générer des avant-projets et à rédiger mes devis. Un gain de temps inestimable.",
    rating: 5,
  },
  {
    name: "Sophie",
    role: "Directrice",
    company: "Hôtel de charme",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    quote: "Les réponses automatiques aux avis et la génération de contenus ont transformé notre communication digitale.",
    rating: 5,
  },
];

export const footerContent = {
  company: {
    name: "ACDC-Formation x FormActionPro",
    description: "Formations et conseil en IA générative, management, soft skills et digital pour les PME, artisans et professions libérales.",
    address: "7 avenue Paul Cézanne",
    postalCode: "83600",
    city: "Cogolin",
    phone: "06 78 26 91 10 / 07 69 05 76 73",
    email: "contact@acdc-formation.com",
    website: "[acdc-formation.com / formactionpro.net]",
    responsable: "[David Contal / François Schoonheere]",
    hebergeur: "[Vercel]",
  },
  links: [
    { label: "Mentions légales", href: "/mentions-legales" },
    { label: "Politique de confidentialité", href: "/confidentialite" },
    { label: "CGV", href: "/cgv" },
    { label: "Cookies", href: "#cookies" },
  ],
  social: [
    { name: "LinkedIn", href: "https://linkedin.com" },
    { name: "Twitter", href: "https://twitter.com" },
  ],
};

export default {
  heroContent,
  painPoints,
  services,
  methodology,
  useCases,
  pricing,
  testimonials,
  footerContent,
};
